import { apiPost } from "./api";
import type { ID } from "./id";

/**
 * A change to a running competition's live domain, as a live command
 * (R25): the cloud page sends what a hall device would, through the
 * sequencer, instead of its CRUD write.
 */
export function liveCommand(competitionId: ID, type: string, data: unknown) {
  return apiPost(`/live/${competitionId}/commands`, {
    command_id: crypto.randomUUID(),
    type,
    data,
  });
}
